export enum Discount {
  OFFERS = 'offers',
  COUPONS = 'coupons',
}
